import React from 'react';
import camelCase from 'lodash/camelCase';
import { isFedRamp } from '@atlassian/atl-context';
import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { forgeProjectModuleResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/forge/index.tsx';
import { horizontalNavJiraResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/horizontal-navigation/horizontal-nav-jira/index.tsx';
import { staticProjectSidebarConnectAddonsNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar-connect-addons/index.tsx';
import { staticProjectSidebarNavigationResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-project-sidebar/index.tsx';
import { staticSidebarShortcutsResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-sidebar-shortcuts/index.tsx';
import AsyncSidebarSoftwareClassic from '@atlassian/jira-navigation-apps-sidebar-software-classic/src/async.tsx';
import { Skeleton } from '@atlassian/jira-periscope/src/ui/skeleton/index.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { projectContextResource } from '@atlassian/jira-router-resources-project-context/src/services/project-context/index.tsx';
import { incidentExperimentTraitResource } from '@atlassian/jira-router-resources-software-incidents/src/services/index.tsx';
import ErrorPagesNotFound from '@atlassian/jira-router-routes-common/src/ui/error-pages/not-found/index.tsx';
import { softwarePeriscopeClassicRoute } from '@atlassian/jira-router-routes-software-periscope-routes/src/softwarePeriscopeClassicRoute.tsx';
import { AsyncHorizontalNavJira } from '@atlassian/jira-horizontal-nav/src/async.tsx';
import { classicSoftwareProjectLayout } from '@atlassian/jira-software-project-layout/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { notFoundPageEntrypoint } from '@atlassian/jira-router-routes-not-found-entrypoint/src/ui/error-pages/not-found/index.tsx';
import { rovoEntitlementResource } from '@atlassian/jira-router-resources-rovo-entitlement/src/services/index.tsx';
import { LazyPeriscope } from './common/periscope-old.tsx';
import { periscopeEntryPoint } from './common/periscope.tsx';

const PeriscopeClassic = () => (
	<LazyPage Page={LazyPeriscope} pageId="softwarePeriscopeClassic" shouldShowSpinner />
);

const getHorizontalNavJiraResource = () => {
	return fg('thor-migrate-periscope-route-to-entry-points') ? [] : [horizontalNavJiraResource];
};

export const softwarePeriscopeClassicRouteEntry = createEntry(
	softwarePeriscopeClassicRoute,
	() => ({
		group: 'classic-software',
		skeleton: Skeleton,
		resources: [
			...getNavigationResources(),
			// these have been expanded from getNavigationSidebarProjectResource - please examine whether your route requires these resources in nav4 and remove them with the getWillShowNav4 feature gate if it does not
			incidentExperimentTraitResource,
			projectContextResource,
			forgeProjectModuleResource,
			staticSidebarShortcutsResource,
			staticProjectSidebarNavigationResource,
			staticProjectSidebarConnectAddonsNavigationResource,
			...getHorizontalNavJiraResource(),
			// end of resources expanded from getNavigationSidebarProjectResource
			projectContextResource,
			rovoEntitlementResource,
		],
		component: componentWithCondition(isFedRamp, ErrorPagesNotFound, PeriscopeClassic),
		layout: classicSoftwareProjectLayout,
		navigation: {
			menuId: MENU_ID.PROJECTS,
			sidebar: AsyncSidebarSoftwareClassic,
			horizontal: AsyncHorizontalNavJira,
			onlyShowHorizontalOnNav4: true,
		},
		forPaint: fg('thor-migrate-periscope-route-to-entry-points')
			? undefined
			: [LazyAtlassianNavigation, LazyPeriscope],
		entryPoint: () => {
			if (fg('thor-migrate-periscope-route-to-entry-points')) {
				return isFedRamp() ? notFoundPageEntrypoint : periscopeEntryPoint;
			}
			return undefined;
		},
		meta: {
			reporting: {
				id: 'software-periscope-classic',
				packageName: camelCase('software-periscope-classic'),
				teamName: 'nova',
			},
		},
	}),
);
